export const fr = {
  login: "Connexion",
  configure: "Configurez",
  your_vehicule: "votre véhicule",
  configurator: "Configurateur",
  our_models: "Nos modèles",
  error: "Erreur",
  error_title: "Oups, il y'a un problème !",
  and_vehicles: "et véhicules",
  home: "Accueil",
  previous: "Précédent",
  all_about_aixam: "Tout savoir sur Aixam",
  models: "Modèles",
  changing_models: "Changer de modèle",
  read_more: "Lire la suite",
  discover_the_types_of_vehicles: "Découvrez les types de véhicules",
  type_of_vehicle: "Types de véhicules",
  back_to_aixam_model_presentation: "Retour présentation modèles Aixam",
  changing_vehicle_type: "Changer de type de véhicule",
  in_pictures: ({ plural, named }) =>
    plural([`La ${named("name")} en image`, `Le ${named("name")} en image`]),
  return: "Retour",
  gallery: "Galerie",
  discover: "Découvrez",
  installment_from: "à partir de {price}€/mois",
  installment_rate_by_month: "/ mois + 1er loyer de {price} €",
  installment: "{price}€/mois",
  price_from: "à partir de {price} €",
  or: "ou",
  month: "mois",
  first_rent: "1er loyer de {price} €",
  features: "Caractéristiques",
  basic_equipment: "Équipement de base",
  options: "Options",
  base_rate: "Tarif de base",
  location_rate: "Tarif en location longue durée",
  equipment_and_options_tariff: "Tarif équipement et options",
  motor: "Moteur",
  label: "Moteur",
  position: "Disposition",
  size: "Cylindrée (cm3)",
  cylinder_position_and_number: "Nb et disposition des cylindres",
  fuel_supply_and_emission_control: "Alimentation et dépollution",
  colling_system: "Refroidissement",
  max_power: "Puissance maximal kW",
  torque: "Couple (mN)",
  max_engine_speed: "Régime maxi en charge (tr/min)",
  fuel: "Carburant",
  alternator: "Alternateur (W)",
  battery: "Batterie",
  administrative_power: "Puissance administrative",
  unlicensed_vehicle: "Véhicule sans permis",
  these_price_include: "Ces prix comprennent :",
  transport: "le transport,",
  preparation: "la préparation,",
  labour: "la main d'oeuvre de la 1ère révision 1000 km,",
  assistance: "l'assistance dépannage 2 ans.",
  these_price_do_not_include: "Ces prix ne comprennent pas :",
  fees: "les frais & plaques d'immatriculation,",
  fuel_and_services:
    "le plein de carburant (version thermique uniquement) & services.",
  maximum_fees: "Montant total maximum des frais :",
  vehicles_without_licence: "pour les véhicules sans permis",
  credit_engagment:
    "Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous engager.",
  available_options: "Options disponibles",
  colors: "Coloris du modèle",
  continue: "Continuer",
  back_home: "Retour à l'accueil",
  inactivity_title: "Êtes-vous toujours là ?",
  inactivity_message:
    "L'application va se réinitialiser, voulez-vous continuer ?",
  your_code: "Votre code d'activation",
  close: "Fermer",
};
